import { render, staticRenderFns } from "./PamReplyComment.vue?vue&type=template&id=466ff81c"
import script from "./PamReplyComment.vue?vue&type=script&lang=js"
export * from "./PamReplyComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports